import { IconMessageLine24, UIText3 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import styles from './IconMessage.css';
import { IApplicationState } from '../../../../types/redux';

export const IconMessage: React.FC = () => {
  const messageCount = useSelector<IApplicationState, number>(state => state.messages.count);

  return (
    <div className={styles['icon-message']}>
      <IconMessageLine24 color="current_color" />

      {messageCount > 0 && (
        <div className={styles['message-counter']}>
          <UIText3 color="white_100">{messageCount}</UIText3>
        </div>
      )}
    </div>
  );
};
